import { render, staticRenderFns } from "./InputPlaceholder.vue?vue&type=template&id=faeaf738&scoped=true&"
import script from "./InputPlaceholder.vue?vue&type=script&lang=js&"
export * from "./InputPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./InputPlaceholder.vue?vue&type=style&index=0&id=faeaf738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeaf738",
  null
  
)

export default component.exports